// Stille console op productie. Fouten blijven zichtbaar; de rest alleen in
// development, of op productie na `localStorage.setItem('bb-debug', '1')`.
const debugWanted = (() => {
  try { return localStorage.getItem('bb-debug') === '1'; } catch { return false; }
})();

if (import.meta.env.PROD && !debugWanted) {
  const noop = () => {};
  for (const m of ['log', 'info', 'debug', 'trace', 'warn']) console[m] = noop;
}
